module.exports = __webpack_public_path__ + "img/mas.c08246bf.png";